<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-09-01 18:28:08
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:19:57
-->
<template>
  <div :class="readonly ? '' : 'box'" class="numbox">
    <v-text-field
      :height="height"
      :maxlength="maxlength"
      :label="label"
      :rules="rules"
      :readonly="readonly"
      :background-color="
        backgroundColor ? backgroundColor : readonly ? '' : '#f5f5f5'
      "
      :class="readonly ? '' : 'bigbox'"
      placeholder=" "
      @change="change"
      v-bind="$attrs"
      v-on="$listeners"
      :value="nums"
    >
      <v-icon
        slot="prepend-inner"
        class="mt-1 ml-2"
        v-if="!readonly"
        @click="remove()"
        >mdi-minus</v-icon
      >
      <v-icon slot="append" class="mt-1 mr-2" v-if="!readonly" @click="add()"
        >mdi-plus</v-icon
      >
    </v-text-field>
  </div>
</template>

<script>
/**
 * 数字输入框
 */
export default {
  components: {},
  props: {
    maxlength: {
      //默认vue最大长度
      type: [String, Number],
      default: 3,
    },
    valueLength: {
      //显示长度默认 000-999   接受布尔值不做限制
      type: [String, Number, Boolean],
      default: 3,
    },
    type: {
      type: String,
      default: "Number",
    },
    backgroundColor: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    rules: {},
    label: {
      type: String,
    },
    height: {
      type: String,
      default: "40",
    },
    placeholder: {
      type: String,
      default: "",
    },
    num: {
      type: [Number, String],
    },
  },
  model: {
    prop: "num",
    event: "changeNum",
  },
  data() {
    return {
      // rules: [v => (v ? /^\d{maxlength}$/.test(v) : !v) || '只能输入000-999的数字'],
      color: false,
    };
  },
  computed: {
    nums: {
      get() {
        return this.num === "" || this.num === undefined
          ? ""
          : this.PrefixInteger(this.num, this.valueLength);
      },
      set(v) {
        // console.log(v);
      },
    },
  },
  created() {},
  watch: {},
  mounted() {},
  methods: {
    // num传入的数字，n需要的字符长度
    PrefixInteger(num, n) {
      if (n === false) return num;
      return (Array(n).join(0) + num).slice(-n);
    },
    change(v) {
      if (this.type == "Number") {
        this.$emit("changeNum", v === "" || v === undefined ? "" : Number(v));
      } else {
        this.$emit("changeNum", this.PrefixInteger(v, this.valueLength));
      }
    },
    remove() {
      let nums = Number(String(this.nums).replace(/[^\d]/g, ""));
      if (this.type == "Number") {
        this.$emit("changeNum", Number(nums) - 1 <= 0 ? 0 : nums - 1);
      } else {
        this.$emit(
          "changeNum",
          Number(nums) - 1 <= 0
            ? this.PrefixInteger(0, this.valueLength)
            : this.PrefixInteger(Number(nums) - 1, this.valueLength)
        );
      }
    },
    add() {
      let nums = Number(String(this.nums).replace(/[^\d]/g, ""));
      if (this.type == "Number") {
        this.$emit("changeNum", Number(nums) + 1 <= 0 ? 0 : nums + 1);
      } else {
        this.$emit(
          "changeNum",
          Number(nums) + 1 <= 0
            ? this.PrefixInteger(0, this.valueLength)
            : this.PrefixInteger(Number(nums) + 1, this.valueLength)
        );
      }
    },
  },
};
</script>

<style scoped>
.numbox /deep/ .v-text-field__slot {
  padding-left: 8px !important;
}
.bigbox /deep/.v-text-field__slot input {
  text-align: center !important;
}
/* .numbox /deep/ .v-label {
  top: 2px !important;
  left: -5px !important;
} */
.box /deep/.v-input .v-label {
  top: -2px !important;
  left: -36px !important;
}
</style>
